import { button } from '../../../../../component/component'

export default function(o,c){

  var rew =
    button(null,'fi-rewind')

  return rew

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/rew/rew.js